import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import InputContainer from './formInputs/containers/InputContainer';
import TextInput from './formInputs/TextInput';

import { setSearchTerm, setAddressSearchTerm } from '../global/actions';
import { searchTerm, addressSearchTerm } from '../global/reducer';

import { filterList } from '../util/filterList';

const GET = 0;
const SET = 1;

export class SearchFilter extends Component {
  componentWillUnmount() {
    this.mapSearchTerm(SET)('');
    clearTimeout(this.debounceUserInputInterval);
  }

  debounceUserInputInterval = null;

  mapSearchTerm = get => {
    const { blnAddressBook, setSearchTerm, setAddressSearchTerm, searchTerm, addressSearchTerm } = this.props;
    if (get === GET) return blnAddressBook ? addressSearchTerm : searchTerm;
    return blnAddressBook ? setAddressSearchTerm : setSearchTerm;
  };

  clearSearch = () => {
    this.mapSearchTerm(SET)('');
    this.updateList();

    const { clearList } = this.props;
    if (clearList) clearList();
  };

  updateList = inputValue => {
    const { filterBy, list, setList, updateList } = this.props;

    if (!list) return null;

    if (updateList) updateList(inputValue);
    if (Array.isArray(setList)) {
      return setList.forEach((set, idx) => set(filterList(list[idx], filterBy, inputValue)));
    }
    if (typeof setList === 'function') {
      return setList(filterList(list, filterBy, inputValue));
    }
    return null;
  };

  debounceUserInput = inputValue => {
    // Sets a timeout before performing the update to the user list.
    // This allows the user to search a long list without the page trying to render with every
    // letter change.
    // MAJOR NOTE: A timeout is used here to debounce input because you cant stop a promise in JS.
    this.mapSearchTerm(SET)(inputValue);
    if (this.debounceUserInputInterval === null || this.debounceUserInputInterval !== 1) {
      clearTimeout(this.debounceUserInputInterval);
      this.debounceUserInputInterval = setTimeout(() => this.updateList(inputValue), 200);
      return null;
    }
    return null;
  };

  render() {
    const { pageName, label } = this.props;

    return (
      <InputContainer label={label} extraClassName='search-input u-full-width' clear={this.clearSearch} isSearch>
        <TextInput
          type='text'
          autoComplete='off'
          name={`${pageName}__search`}
          onChange={this.debounceUserInput}
          value={this.mapSearchTerm(GET)}
          clearable
        />
      </InputContainer>
    );
  }
}

SearchFilter.propTypes = {
  list: PropTypes.arrayOf(PropTypes.any),
  filterBy: PropTypes.arrayOf(PropTypes.string),
  pageName: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  searchTerm: PropTypes.string,
  addressSearchTerm: PropTypes.string,
  setList: PropTypes.oneOfType([PropTypes.func, PropTypes.array]),
  setSearchTerm: PropTypes.func,
  setAddressSearchTerm: PropTypes.func,
  updateList: PropTypes.func,
  clearList: PropTypes.func,
  blnAddressBook: PropTypes.bool
};

SearchFilter.defaultProps = {
  list: null,
  filterBy: null,
  searchTerm: '',
  addressSearchTerm: '',
  setList: null,
  setSearchTerm: null,
  setAddressSearchTerm: null,
  updateList: null,
  clearList: null,
  blnAddressBook: false
};

const mapStateToProps = state => ({
  searchTerm: searchTerm(state),
  addressSearchTerm: addressSearchTerm(state)
});

const connector = connect(mapStateToProps, { setSearchTerm, setAddressSearchTerm });

export default connector(SearchFilter);
